import {keyMirror} from 'utils/DBUtils';

export const Types = keyMirror({
  REQUEST_ENTRIES: null,
  RECEIVED_PRIZE: null,
  RECEIVED_ENTRIES: null,
  SUBMIT_SELECT_WINNERS: null,
  SELECT_WINNERS_SUCCESS: null,
  SELECT_WINNERS_ERROR: null,
  DOWNLOAD_REPORT: null,
  DOWNLOAD_REPORT_SUCCESS: null,
  DOWNLOAD_REPORT_ERROR: null,
  DOWNLOAD_REPORT_CLEAR_MODAL: null,
  START_MANUAL_ENTRY: null,
  END_MANUAL_ENTRY: null,
  SUBMIT_MANUAL_ENTRY: null,
  SUBMIT_MANUAL_ENTRY_SUCCESS: null,
  UPDATE_MANUAL_ENTRY_BREAK_SEARCH: null,
  MANUAL_ENTRY_BREAK_SEARCH_RESULTS_SUCCESS: null
});

export const requestEntriesAction = prizeId => ({
  type: Types.REQUEST_ENTRIES,
  prizeId
});

export const receivedPrizeAction = () => ({
  type: Types.RECEIVED_PRIZE
});

export const receivedEntriesAction = () => ({
  type: Types.RECEIVED_ENTRIES
});

export const submitSelectWinnersAction = prizeId => ({
  type: Types.SUBMIT_SELECT_WINNERS,
  prizeId
});

export const downloadReportAction = prizeId => ({
  type: Types.DOWNLOAD_REPORT,
  prizeId
});

export const downloadReportSuccessAction = prizeId => ({
  type: Types.DOWNLOAD_REPORT_SUCCESS,
  prizeId
});

export const downloadReportErrorAction = prizeId => ({
  type: Types.DOWNLOAD_REPORT_ERROR,
  prizeId
});

export const downloadReportClearModalAction = () => ({
  type: Types.DOWNLOAD_REPORT_CLEAR_MODAL,
});

export const selectWinnersSuccessAction = prizeId => ({
  type: Types.SELECT_WINNERS_SUCCESS,
  prizeId
});

export const selectWinnersErrorAction = () => ({
  type: Types.SELECT_WINNERS_ERROR
});

export const startManualEntryAction = () => ({
    type: Types.START_MANUAL_ENTRY
});

export const endManualEntryAction = () => ({
    type: Types.END_MANUAL_ENTRY
});

export const submitManualEntryAction = (data) => ({
    type: Types.SUBMIT_MANUAL_ENTRY,
    data
});

export const submitManualEntrySuccessAction = () => ({
    type: Types.SUBMIT_MANUAL_ENTRY_SUCCESS
});

export const updateManualEntryBreakSearchAction = (text) => ({
    type: Types.UPDATE_MANUAL_ENTRY_BREAK_SEARCH,
    text
});

export const receivedManualEntryBreakSearchResultsSuccess = (results) => ({
    type: Types.MANUAL_ENTRY_BREAK_SEARCH_RESULTS_SUCCESS,
    results
});



// WEBPACK FOOTER //
// ./public/pages/ListEntries/actions.js